import { Tooltip } from '@material-ui/core';
import * as React from 'react';
import './ChiTooltip.scss';

interface IProps {
    title: string;
    body: any;
    content: any;
    placement?: any;
}

const ChiTooltip = (props: IProps) => {

    return <Tooltip
                classes={{
                    popper: 'chi-popper',
                    tooltip: 'chi-tooltip',
                }}
                placement={ props.placement }
                title={
                    <React.Fragment>
                        <h4>{ props.title }</h4>
                        <div>{ props.body }</div>
                    </React.Fragment>
                }>
               { props.content }
            </Tooltip>;
};

ChiTooltip.defaultProps = {
    content: <button className="tooltip-help-btn" type="button">
                <i className="la la-question-circle" />
            </button>,
    placement: 'bottom'
};

export { ChiTooltip };
